module.exports = __webpack_public_path__ + "img/type3.cad8c209.png";